// The + 1 tolerates Firefox reporting a scrollHeight one pixel larger than
// offsetHeight for text content that is not actually clipped.
export const isTruncated = (element: HTMLElement | null): boolean =>
  Boolean(
    element &&
      (element.offsetWidth < element.scrollWidth ||
        element.offsetHeight + 1 < element.scrollHeight),
  );
